import { render, staticRenderFns } from "./CampanhasTabela.vue?vue&type=template&id=c1f85fd2&scoped=true"
import script from "./CampanhasTabela.vue?vue&type=script&lang=js"
export * from "./CampanhasTabela.vue?vue&type=script&lang=js"
import style0 from "./CampanhasTabela.vue?vue&type=style&index=0&id=c1f85fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f85fd2",
  null
  
)

export default component.exports